<template>
    <AppNavigation>
        <mdb-container fluid>
            <h1 class="h1-responsive">Zone Coverage</h1>
            <hr>
            <div id="map"></div>
            <mdb-tbl responsive striped>
                <mdb-tbl-head>
                    <tr>
                        <th width="5%">#</th>
                        <th>Name</th>
                        <th>Daily Start Time / End Time</th>
                        <th>Cross Zone</th>
                        <th>Rider</th>
                        <th>Merchant</th>
                        <th>Actions</th>
                    </tr>
                </mdb-tbl-head>
                <mdb-tbl-body>
                    <tr>
                        <td>#</td>
                        <td>
                            <div class="form-group" style="margin-top: 1.5rem">
                                <input type="text" v-model="new_zone.name" class="form-control">
                            </div>
                        </td>
                        <td>
                            <div>
                                <mdb-time-picker
                                    outline
                                    v-model="new_zone.operating_start"
                                    :hoursFormat="24"
                                    style="background-color: #fff; margin: 0;"
                                />
                            </div>
                            <div>
                                <mdb-time-picker
                                    outline
                                    v-model="new_zone.operating_end"
                                    :hoursFormat="24"
                                    style="background-color: #fff; margin: 0;"
                                />
                            </div>
                        </td>
                        <td>
                            <div class="form-group" style="margin-top: 1.5rem">
                                <label>Merchant Search KM</label>
                                <input type="text" v-model="new_zone.cross_merchant_search_km" class="form-control">
                            </div>
                            <div class="form-group" style="margin-top: 1.5rem">
                                <label>Rider Search KM</label>
                                <input type="text" v-model="new_zone.cross_partner_search_km" class="form-control">
                            </div>
                        </td>
                        <td>
                            <div class="form-group" style="margin-top: 1.5rem">
                                <label>Rider Search Area</label>
                                <input type="text" v-model="new_zone.partner_search_area" class="form-control">
                            </div>
                            <div class="form-group" style="margin-top: 1.5rem">
                                <label>Rider Search KM</label>
                                <input type="text" v-model="new_zone.partner_search_km" class="form-control">
                            </div>
                        </td>
                        <td>
                            <div class="form-group" style="margin-top: 1.5rem">
                                <label>Merchant Search Area</label>
                                <input type="text" v-model="new_zone.merchant_search_area" class="form-control">
                            </div>
                            <div class="form-group" style="margin-top: 1.5rem">
                                <label>Merchant Search KM</label>
                                <input type="text" v-model="new_zone.merchant_search_km" class="form-control">
                            </div>
                        </td>
                        <td>
                            <mdbBtn color="primary" style="margin-top: 1.5rem" :disabled="checkAddZoneValidity()" @click="addNewZone" size="sm">Add New Zone</mdbBtn>
                        </td>
                    </tr>
                    <tr v-for="(zone, index) in zones" :key="zone.id">
                        <td>{{index+1}}</td>
                        <td>
                            <div class="form-group" style="margin-top: 1.5rem;" >
                                <label>Zone Name</label>
                                <input type="text" :style="{'color': zone.color}" v-model="zone.name" class="form-control">
                            </div>
                        </td>
                        <td>
                            <div>
                            <mdb-time-picker
                                outline
                                label="Operating Start Time"
                                v-model="zone.operating_start"
                                :hoursFormat="24"
                                style="background-color: #fff; margin: 0;"
                            />
                            </div>
                            <div>
                            <mdb-time-picker
                                label="Operating End Time"
                                outline
                                v-model="zone.operating_end"
                                :hoursFormat="24"
                                style="background-color: #fff; margin: 0;"
                            />
                            </div>
                        </td>
                        <td>
                            <div class="form-group" style="margin-top: 1.5rem">
                                <label>Cross Merchant Search KM</label>
                                <input type="text" v-model="zone.cross_merchant_search_km" class="form-control">
                            </div>
                            <div class="form-group" style="margin-top: 1.5rem">
                                <label>Cross Rider Search KM</label>
                                <input type="text" v-model="zone.cross_partner_search_km" class="form-control">
                            </div>
                        </td>
                        <td>
                            <div class="form-group" style="margin-top: 1.5rem">
                                <label>Rider Search Area</label>
                                <input type="text" v-model="zone.partner_search_area" class="form-control">
                            </div>
                            <div class="form-group" style="margin-top: 1.5rem">
                                <label>Rider Search KM</label>
                                <input type="text" v-model="zone.partner_search_km" class="form-control">
                            </div>
                        </td>
                        <td>
                            <div class="form-group" style="margin-top: 1.5rem">
                                <label>Merchant Search Area</label>
                                <input type="text" v-model="zone.merchant_search_area" class="form-control">
                            </div>
                            <div class="form-group" style="margin-top: 1.5rem">
                                <label>Merchant Search KM</label>
                                <input type="text" v-model="zone.merchant_search_km" class="form-control">
                            </div>
                        </td>
                        <td>
                            <mdbBtn color="primary" @click="view(zone)" size="sm"><mdb-icon far icon="eye" /></mdbBtn>
                            <mdbBtn color="success" @click="updateZone(zone)" size="sm"><mdb-icon far icon="save" /></mdbBtn>
                            <mdbBtn color="danger" @click="confirmDeleteZone(zone)" size="sm"><mdb-icon far icon="trash-alt" /></mdbBtn>
                        </td>
                    </tr>
                </mdb-tbl-body>
            </mdb-tbl>
            <ConfirmationModal :visible="confirmation_modal" :close="closeModalComponent" title="Confirm Delete Zone?" :submit="deleteZone" />
            <ZoneCoverageModal :zone="focus_zone" :zones="zones" :visible="zone_coverage_modal" :close="closeModalComponent"/>
        </mdb-container>
    </AppNavigation>
</template>

<script>
// @ is an alias to /src
import {mdbContainer, mdbTbl, mdbTblHead, mdbTblBody, mdbBtn, mdbIcon, mdbTimePicker} from 'mdbvue';
import AppNavigation from '../components/AppNavigation';
import {ajax} from '../js/ajax';
import ConfirmationModal from '../components/ConfirmationModal';
import {validateRequired, validatePercentage} from '../js/validation';
import ZoneCoverageModal from '../components/ZoneCoverageModal';
import {checkPermissionsBinary} from '../js/helper';

export default {
  name: 'zone_coverage',
  components: {
    mdbContainer, mdbTbl, mdbTblHead, mdbTblBody, mdbTimePicker,
    AppNavigation, mdbBtn, ConfirmationModal, mdbIcon,
    ZoneCoverageModal
  },
  data: ()=>({
        zones: [],
        new_zone: {
            name: "",
            operating_start: "",
            operating_end: "",
            partner_search_area: "",
            partner_search_km: "",
            merchant_search_area: "",
            merchant_search_km:"",
            cross_merchant_search_km: "",
            cross_partner_search_km: ""
        },
        loading: false,
        confirmation_modal: false,
        focus_id: 0,
        zone_coverage_modal: false,
        focus_zone: null
  }),
  methods: {
      closeModalComponent(){
          this.confirmation_modal=false;
          this.zone_coverage_modal=false;
      },
      confirmDeleteZone(zone){
          this.focus_id=zone.id;
          this.confirmation_modal=true;
      },
      deleteZone(){
        let permissions=this.$store.state.permissions;
        if(!checkPermissionsBinary(46, permissions)){
            this.$notify.warn({message: "Access Denied", position: 'top right', timeOut: 5000})
            return false;
        }
        this.loading=true;
        ajax({
            url: "admin/delete_zone",
            data: {id: this.focus_id},
            success: ()=>{
                this.$notify.success({message: "Zone Deleted", position: 'top right', timeOut: 5000})
                this.getData();
            },
            complete: ()=>this.loading=false,
            fail: fail=>this.$notify.error({message: fail.message, position: 'top right', timeOut: 5000})
        })
      },
      addNewZone(){
        let permissions=this.$store.state.permissions;
        if(!checkPermissionsBinary(46, permissions)){
            this.$notify.warn({message: "Access Denied", position: 'top right', timeOut: 5000})
            return false;
        }
        this.loading=true;
        ajax({
            url: "admin/add_new_zone",
            data: this.new_zone,
            success: ()=>{
                this.$notify.success({message: "Zone Added", position: 'top right', timeOut: 5000})
                this.new_zone={
                    name: "",
                    operating_start: "",
                    operating_end: "",
                    partner_search_area: "",
                    partner_search_km: "",
                    merchant_search_area: "",
                    merchant_search_km:"",
                    cross_merchant_search_km: "",
                    cross_partner_search_km: ""
                };
                this.getData();
            },
            complete: ()=>this.loading=false,
            fail: fail=>this.$notify.error({message: fail.message, position: 'top right', timeOut: 5000})
        })
      },
      updateZone(zone){
        let permissions=this.$store.state.permissions;
        if(!checkPermissionsBinary(46, permissions)){
            this.$notify.warn({message: "Access Denied", position: 'top right', timeOut: 5000})
            return false;
        }
        this.loading=true;
        ajax({
            url: "admin/update_zone",
            data: zone,
            success: ()=>{
                this.$notify.success({message: "Zone Updated", position: 'top right', timeOut: 5000})
                this.getData();
            },
            complete: ()=>this.loading=false,
            fail: fail=>this.$notify.error({message: fail.message, position: 'top right', timeOut: 5000})
        })
      },
      checkAddZoneValidity(){
            if(!validateRequired(this.new_zone.name)){
                return true;
            }
            if(!validateRequired(this.new_zone.operating_start)){
                return true;
            }
            if(!validateRequired(this.new_zone.operating_end)){
                return true;
            }
            if(!validatePercentage(this.new_zone.partner_search_area)){
                return true;
            }
            return false;
      },
      getData(){
        ajax({
            url: "admin/get_zone_coverage",
            success: result=>{
                this.zones=result.data;
                this.renderMap();
            },
            fail: fail=>this.$notify.error({message: fail.message, position: 'top right', timeOut: 5000})
        }) 
      },
      renderMap(){
        const google = window.google;
        if(!this.map){
            var mapProp = {
                center:new google.maps.LatLng(3.0764785,101.4828676),
                zoom:12,
            };
            this.map=new google.maps.Map(document.getElementById("map"),mapProp);
        }
        this.zones.forEach(zone=>{
            zone.zone_coverage.forEach(coverage=>{
                const coverage_geolocation = [
                    { lat: parseFloat(coverage.lat_1), lng: parseFloat(coverage.lng_1) },
                    { lat: parseFloat(coverage.lat_2), lng: parseFloat(coverage.lng_2) },
                    { lat: parseFloat(coverage.lat_3), lng: parseFloat(coverage.lng_3) },
                    { lat: parseFloat(coverage.lat_4), lng: parseFloat(coverage.lng_4) },
                ];
                // Construct the polygon.
                const coverage_map = new google.maps.Polygon({
                    paths: coverage_geolocation,
                    strokeColor: zone.color,
                    strokeOpacity: 0.8,
                    strokeWeight: 2,
                    fillColor: zone.color,
                    fillOpacity: 0.35,
                });                
                coverage_map.setMap(this.map);  
                var label_latlng = new google.maps.LatLng(coverage.lat_1, coverage.lng_1);

                var marker = new google.maps.Marker({
                    position: label_latlng,
                    title:'CoverageID: '+coverage.id+' Zone Name: '+zone.name
                });
                marker.setMap(this.map);
            })
        })
      },
      view(zone){
          this.focus_zone=zone;
          this.zone_coverage_modal=true;
      }
  },
  mounted: function(){
      this.getData();
  }
}
</script>

<style scoped>
#map{
    height: 70vh;
    width: 100%;
    margin-bottom: 5rem;
}
</style>